import axios from 'axios';
import ReactDOMServer from 'react-dom/server';
import ContactUsMessageLayout from './ContactUsMessageLayout';

const ContactUsMessage = (data) => {
  const htmlEncodedString = ReactDOMServer.renderToStaticMarkup(
    <ContactUsMessageLayout data={data} />
  );

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlEncodedString, 'text/html');
  const htmlContent = doc.body.textContent;

  const formData = new FormData();
  formData.append('htmlContent', htmlContent);

  return new Promise((resolve, reject) => {
    axios
      .post('/users/contactUs', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default ContactUsMessage;
